import React from "react";
import { useDeleteSavedViewHook } from "./DeleteSavedViewDialog.hooks";
import { SavedView } from "../SavedViewsMenu.types";
import { useTranslation } from "../../../../localization/useTranslation";
import DotLegalDeleteDialogWrapper from "../../dotLegalDeleteDialog/DotLegalDeleteDialogWrapper.tsx";
import { isNullOrWhitespace } from "../../../stringOperations.ts";

export interface IDeleteSavedViewDialog {
    view: SavedView;
    onCloseDialog: () => void;
    onSuccessDelete: () => void;
}

function DeleteSavedViewDialog(props: IDeleteSavedViewDialog) {
    const { translateString } = useTranslation();
    const { removeViewClick, inProgress } = useDeleteSavedViewHook(props);

    return (
        <DotLegalDeleteDialogWrapper
            open
            itemForDeletion={props.view.name}
            onDialogClose={props.onCloseDialog}
            onOkClick={removeViewClick}
            inProgress={inProgress}
            additionalWarning={isNullOrWhitespace(props.view.userId) ? translateString("deleteGlobalViewWarning") : undefined}
        />
    );
}

export default DeleteSavedViewDialog;
